'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = require('../FormInputs/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Radio = require('../FormInputs/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _Slider = require('../FormInputs/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _Text = require('../FormInputs/Text');

var _Text2 = _interopRequireDefault(_Text);

var _SingleSelect = require('../FormInputs/Select/SingleSelect');

var _SingleSelect2 = _interopRequireDefault(_SingleSelect);

var _GenericType = require('./GenericType');

var _GenericType2 = _interopRequireDefault(_GenericType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Question = function (_Component) {
  _inherits(Question, _Component);

  function Question() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Question);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Question.__proto__ || Object.getPrototypeOf(Question)).call.apply(_ref, [this].concat(args))), _this), _this.getProps = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          type = _this$props.type,
          choices = _this$props.choices,
          answer = _this$props.answer,
          _onChange = _this$props.onChange,
          placeholder_text = _this$props.placeholder_text,
          otherProps = _objectWithoutProperties(_this$props, ['id', 'type', 'choices', 'answer', 'onChange', 'placeholder_text']);

      return _extends({}, otherProps, {
        placeholder: placeholder_text,
        options: choices,
        value: answer,
        onChange: function onChange(value) {
          return _onChange(id, value);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Question, [{
    key: 'render',
    value: function render() {
      var Component = void 0;
      switch (this.props.displayType) {
        case 'checkbox':
          Component = _Checkbox2.default;
          break;
        case 'radio':
          Component = _Radio2.default;
          break;
        case 'slider':
          Component = _Slider2.default;
          break;
        case 'text':
          Component = _Text2.default;
          break;
        case 'single_select':
        case 'multi_select':
          Component = _SingleSelect2.default;
          break;
        default:
          Component = _GenericType2.default;
      }
      return _react2.default.createElement(Component, _extends({ className: 'survey-question' }, this.getProps()));
    }
  }]);

  return Question;
}(_react.Component);

Question.propTypes = {
  id: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string,
  answer: _propTypes2.default.any,
  choices: _propTypes2.default.any,
  displayType: _propTypes2.default.string
};

Question.defaultProps = {};

exports.default = Question;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Survey/Question.js
// module id = 457
// module chunks = 0